const CENTER_COLUMN_WIDTH_PER_HEIGHT = 16 / 15;
const SIDER_GUTTER = 160;
const SIDER_HEIGHT_RATIO = 0.8;
const CHROME_BAR_HEIGHT_DIVISOR = 10;

export function getCenterColumn(widthContent: number, heightContent: number) {
  const width = heightContent * CENTER_COLUMN_WIDTH_PER_HEIGHT;
  return { left: (widthContent - width) / 2, width };
}

export function getSiderSize(widthContent: number, heightContent: number) {
  const centerWidth = getCenterColumn(widthContent, heightContent).width;
  return {
    width: (widthContent - (centerWidth + SIDER_GUTTER)) / 2,
    height: heightContent * SIDER_HEIGHT_RATIO,
  };
}

export function getChromeBarHeight(heightContent: number) {
  return heightContent / CHROME_BAR_HEIGHT_DIVISOR;
}
